// @ts-ignore
import { data as css } from './asset-item.css';

import DomainModel from '../../../domain-model';
import elt from '../../../html/elt';
import injectCSS from '../../../html/inject-css';
import logging from '../../../logging';


const log = logging('components');

export default class AssetItem extends HTMLElement {
    image: HTMLImageElement;
    label: HTMLElement;

    prototype: DomainModel;

    constructor(label: string, prototype: DomainModel) {
        super();
        injectCSS(css);
        this.prototype = prototype;
        this.label = elt('label', {}, label ?? '[label]');
    }

    connectedCallback() {
        const frame = elt('div', {class: 'frame'});
        this.image = elt('img');

        this.replaceChildren(); // clear our contents

        // Note that since we're not using drag events, it's actually important
        // that this not be draggable. If this (especially the image) were
        // draggable, then the dragged item would not emit normal pointer
        // events over the drop target.
        this.setAttribute('draggable', 'false');
        this.image.setAttribute('draggable', 'false');

        frame.append(this.image, this.label);
        this.append(frame)
    }

    static observedAttributes = ['src'];

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        if(name == 'src') {
            this.image.src = newValue;
        }
    }

}
window.customElements.define('asset-item', AssetItem);

